import { get, post, put, patch } from "../../../services/api/Config"

export function SearchPageSettingList({ params = {}, lang }) {
  return get({ url: `/v1/admin/page-setting`, params, lang })
}
export function SearchPageSetting(componentKey, { params = {}, lang }) {
  return get({ url: `/v1/admin/page-setting/get/${componentKey}`, params, lang })
}

export function SavePageSetting(componentKey, { params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/page-setting/post/${componentKey}`, params, data, lang })
}

export function UpdatePageSetting(componentKey, { params = {}, data = {}, lang }) {
  return put({ url: `/v1/admin/page-setting/put/${componentKey}`, params, data, lang })
}

export function SearchPageDetail(componentKey, { params = {}, lang }) {
  return get({ url: `/v1/admin/page-detail/get/${componentKey}`, params, lang })
}

export function SavePageDetail(componentKey, { params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/page-detail/post/${componentKey}`, params, data, lang })
}

export function UpdatePageDetail(componentKey, { params = {}, data = {}, lang }) {
  return put({ url: `/v1/admin/page-detail/put/${componentKey}`, params, data, lang })
}

